import {Injectable, Signal} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {map} from "rxjs";
import {getAllRouteData} from "../utils";
import {toSignal} from "@angular/core/rxjs-interop";
import {RouteData} from "../app.routes";

@Injectable({
  providedIn: 'root'
})
export class RouteDataService {

  constructor(private readonly route: ActivatedRoute,
              private readonly router: Router) {
  }

  private readonly routeData$ = this.router.events.pipe(
    map(() => getAllRouteData(this.route)))

  public readonly routeData: Signal<RouteData> = toSignal(this.routeData$, {initialValue: {}});
}
